import React from 'react';
import { useSelector } from 'react-redux';
import Immutable from 'immutable';

import {
  NavigationScroll,
} from '@uncinc/uncinc-react-kitchen-sink';

import {
  CampaignNavigation,
  ProgressBar,
} from '..';

import Navigation from '../../implementations/Navigation';

const SUPPORTED_PROGRESS_BAR_TYPES = [
  'download',
  'article',
  'basic_page',
  'interventie',
  'praktijkvoorbeeld',
  'onderzoek',
  'milestones',
];

const Header = ({ pageRef }) => {
  const currentEntityId = useSelector((state) => state.getIn(['entity', 'entityId'], null));
  const currentEntity = useSelector((state) => state.getIn(['node', currentEntityId], Immutable.Map()));
  const currentEntityType = currentEntity.getIn(['type', 0, 'target_id'], '');
  const currentTaxonomyType = useSelector((state) => state.getIn(['taxonomyTerm', currentEntityId, 'vid', 0, 'target_id'], ''));

  const campaign = currentEntity.getIn(['field_campaign', 0, 'entity'], null);
  const campaignSlogan = currentEntity.getIn(['field_campaign', 0, 'entity', 'field_slogan', 0, 'value'], null);

  return (
    <header className="Header" id="Header">
      <NavigationScroll>
        <>
          <Navigation />
          {(
            SUPPORTED_PROGRESS_BAR_TYPES.includes(currentEntityType)
            || SUPPORTED_PROGRESS_BAR_TYPES.includes(currentTaxonomyType)
          ) && (
            <ProgressBar scrollAreaRef={pageRef} />
          )}
          {(campaign && campaignSlogan) && (
            <CampaignNavigation slogan={campaignSlogan} />
          )}
        </>
      </NavigationScroll>
    </header>
  );
};

export default Header;
